<template>
  <div>
    <div class="select-wrapper">
      <div class="select-item-wrapper">
        <v-select
          @change="selectChanged"
          :items="chartItemsArray[0]"
          v-model="selected1"
        />
      </div>
      <div class="select-item-wrapper">
        <v-select
          @change="selectChanged"
          :items="chartItemsArray[1]"
          v-model="selected2"
          pl-1
        />
      </div>
    </div>
    <VueC3 :handler="chartHandler" />
  </div>
</template>

<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'

import ChartUtils from '@/components/Advertiser/Report/StandardReport/ChartUtils'

const chartItems = [
  {
    text: '消化金額',
    value: 'revenueBuyingCurrency',
  },
  {
    text: 'インプレッション',
    value: 'imps',
  },
  {
    text: 'クリック',
    value: 'clicks',
  },
  {
    text: 'CTR',
    value: 'ctr',
  },
  {
    text: 'CPC',
    value: 'cpc',
  },
  {
    text: 'CPM',
    value: 'cpm',
  },
]

const chartItemsWithNull = [
  {
    text: 'なし',
    value: 'null',
  },
  {
    text: '消化金額',
    value: 'revenueBuyingCurrency',
  },
  {
    text: 'インプレッション',
    value: 'imps',
  },
  {
    text: 'クリック',
    value: 'clicks',
  },
  {
    text: 'CTR',
    value: 'ctr',
  },
  {
    text: 'CPC',
    value: 'cpc',
  },
  {
    text: 'CPM',
    value: 'cpm',
  },
]

export default {
  name: 'Chart',
  components: { VueC3 },
  props: {
    chartData: Array,
    isHideRevenue: Boolean,
  },
  data: () => ({
    chartHandler: new Vue(),
    selected1: 'revenueBuyingCurrency',
    selected2: 'clicks',
  }),

  computed: {
    chartSelectedArray() {
      return ChartUtils.makeChartSelectedArray(this.selected1, this.selected2)
    },
    chartItemsArray() {
      const item1 = chartItems.filter(
        o =>
          o.value !== this.selected2 &&
          (this.isHideRevenue
            ? ['imps', 'clicks', 'ctr'].includes(o.value)
            : true),
      )
      const item2 = chartItemsWithNull.filter(
        o =>
          o.value !== this.selected1 &&
          (this.isHideRevenue
            ? ['imps', 'clicks', 'ctr', 'null'].includes(o.value)
            : true),
      )
      return [item1, item2]
    },
  },
  watch: {
    chartData() {
      this.emitChartHandler()
    },
    isHideRevenue() {
      if (this.isHideRevenue) {
        this.selected1 = 'imps'
      } else {
        this.selected1 = 'revenueBuyingCurrency'
      }
    },
  },
  mounted() {
    this.emitChartHandler()
  },
  created() {
    this.selected1 = this.isHideRevenue ? 'imps' : 'revenueBuyingCurrency'
    this.selected2 = this.isHideRevenue ? 'clicks' : 'null'
  },
  methods: {
    emitChartHandler() {
      const options = ChartUtils.makeChartOptions({
        chartSelectedArray: this.chartSelectedArray,
        chartData: this.chartData,
      })
      this.chartHandler.$emit('init', options)
    },
    selectChanged() {
      this.emitChartHandler()
    },
  },
}
</script>

<style scoped lang="scss">
.select-wrapper {
  display: flex;
}
.select-item-wrapper {
  width: 140px;
  &:first-child {
    margin-left: 30px;
  }
  &:last-child {
    margin-left: 20px;
  }
}
</style>
